export default __webpack_public_path__ + "static/media/kathrynholston.b15e0d31.png";